const CONTENT_LOCALES = Object.freeze({
  zhCN: {
    code: 'zh-CN',
    name: 'Simplified Chinese',
    shortName: 'Simplified',
  },
  zhHK: {
    code: 'zh-HK',
    name: 'Traditional Chinese',
    shortName: 'Traditional',
  },
  enGB: {
    code: 'en-GB',
    name: 'English (British)',
    shortName: 'English',
  },
  enUS: {
    code: 'en-US',
    name: 'English (American)',
    shortName: 'English',
  },
});

const VIDEO_LANGUAGES = Object.freeze({
  ENGLISH: {
    code: 'en-US',
    name: 'English',
  },
  TRADITIONAL_CHINESE: {
    code: 'zh-HK',
    name: 'Traditional Chinese',
  },
  SIMPLIFIED_CHINESE: {
    // Yes. This is considered zh-CN because the English videos are the ones without SC inserts.
    code: 'zh-CN',
    name: 'English (With SC inserts)',
  },
});

const I18N_CONTENT_TYPES = Object.freeze({
  presentation: 'presentation',
  sentence: 'sentence',
  word: 'word',
  quiz: 'quiz',
  flashcard: 'flashcard',
  question: 'question',
  coreItemIWGT: 'coreItemIWGT',
  bundle: 'bundle',
  playbook: 'playbook',
});

const SPOKEN_LANGUAGES = Object.freeze({
  CANTONESE: {
    code: 'CANTONESE',
    name: 'Cantonese',
  },
  MANDARIN: {
    code: 'MANDARIN',
    name: 'Mandarin',
  },
});

module.exports = {
  CONTENT_LOCALES,
  VIDEO_LANGUAGES,
  I18N_CONTENT_TYPES,
  SPOKEN_LANGUAGES,
};
